<template>
  <div class="page-title-box">
    <div class="row align-items-center">
      <div class="col-sm-6">
        <h4 class="page-title">Dashboard</h4>
      </div>
      <div class="col-sm-6">
        <ol class="breadcrumb float-right">
          <li class="breadcrumb-item"><a href="#">Jassa</a></li>
          <li class="breadcrumb-item active">Dashboard</li>
        </ol>
      </div>
    </div>
    <!-- end row -->
  </div>

  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Alocar Disciplinas aos Cursos</h4>
        </div>
        <div class="card-body">
          <form @submit.prevent="sendData">
            <div class="row">
              <div class="col-lg-6 col-md-12 col-sm-12">
                <div class="form-group">
                  <label class="form-label">Selecione o Curso</label>
                  <select class="form-control" v-model="formData.id_course">
                    <option :value="c.id" v-for="c in courses" :key="c.id">
                      {{ c.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-lg-6 col-md-12 col-sm-12">
                <div class="form-group">
                  <label for="">Selecione as Disciplinas</label>
                  <v-select
                    v-model="formData.id_subject"
                    :options="Subject"
                    label="name"
                    multiple
                    :reduce="(subject) => subject.id"
                  ></v-select>
                </div>
              </div>

              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="form-label">Selecionar Semestre</label>
                  <select
                    v-model="formData.semester_id"
                    class="form-control custom-select"
                  >
                    <option v-for="s in semesters" :value="s.id" :key="s">
                      {{ s.semester_name }}&#176;
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                  <label class="form-label">Selecionar o ano</label>
                  <select
                    v-model="formData.academic_year_id"
                    class="form-control custom-select"
                  >
                    <option v-for="a in academicYear" :key="a.id" :value="a.id">
                      {{ a.designation }}&#176;
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-lg-12 col-md-12 col-sm-12">
                <button type="submit" class="btn btn-primary">Adicionar</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="table-responsive">
        <table id="example5" class="table table-hover">
          <thead>
            <tr>
              <th>#</th>
              <th>Curso</th>
              <th>Disciplina</th>
              <th>Ano</th>
              <th>Semestre</th>
              <th class="text-center">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(disc, index) in disciplinas" :key="index">
              <td>{{ 1 + index }}</td>
              <td>{{ disc.course_name }}</td>
              <td>{{ disc.subject_name }}</td>
              <td>{{ disc.academic_year_id }}&#176;</td>
              <td>{{ disc.semester_id }}&#176;</td>

              <td aria-colindex="3" role="cell" class="w-140px text-center">
                <div class="action-column">
                  <!-- <a
                    @click="view(index, disc.id)"
                    class="btn btn-sm mr-1 btn-info btn-xs"
                    style="font-size: 13px"
                    ><i class="fa fa-eye text-white"></i>
                  </a>
                  <a
                    @click="edit(index, disc.id)"
                    class="btn btn-sm mr-1 btn-warning btn-xs"
                    style="font-size: 13px"
                    ><i class="fa fa-edit text-white"></i>
                  </a> -->
                  <a
                    @click="confirmBeforeDelete(index, disc.courseSubjec_id)"
                    class="btn btn-sm mr-1 btn-danger btn-xs"
                    style="font-size: 13px"
                    ><i class="fa fa-times text-white"></i>
                  </a>
                </div>
              </td>

              <!-- <td>
                <router-link :to="{name:'editSubject', params:{id_subject:disc.id}}" class="btn btn-sm btn-primary"><i class="fas fa-edit"></i></router-link> &nbsp;
                 <a href="javascript:void(0);"
                @click="isdeleteSubject(disc.id, index)"
                class="btn btn-sm btn-danger"><i class="fas fa-trash"></i></a> 
              </td> -->
            </tr>
          </tbody>
        </table>

        <Page
          :total="total"
          :model-value="current_page"
          :page-size="parseInt(perPage)"
          @on-change="getDisciplinas"
          v-if="total > 0"
          class="float-right"
        />
      </div>
    </div>
  </div>
  <Loading :loadingData="loading"></Loading>
</template>
  
  <script setup>
import { ref } from "vue";
import CourseAndSubjectModule from "./CourseAndSubjectModule";
import store from "@/store";
import toastr from "toastr";
import { onMounted } from "vue";
import { toast } from "vue3-toastify";
import SubjectStoreModule from "../subject/SubjectStoreModule";
import Loading from "../../components/Loading.vue";
import Swal from "sweetalert2";

const formData = ref({
  id_course: "",
  id_subject: [],
  academic_year_id: "",
  semester_id: "",
});
const searchQuery = ref("");
const disciplinas = ref([]);
const courses = ref([]);
const Subject = ref([]);
const academicYear = ref([]);
const semesters = ref([]);
const total = ref(null);
const perPage = ref(10);
const current_page = ref();
const loading = ref(false);

function confirmBeforeDelete(index, id) {
  Swal.fire({
    title: "Tem certeza que deseja eliminar este registro?",
    text: "Todos registros relacionados com esta disciplina serao removidos  e nao tera como reverter esta operacao!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Sim, Eliminar!",
    cancelButtonText: "Cancel!",
  }).then((result) => {
    if (result.isConfirmed) {
      deleteRow(index, id);
    }
  });
}

async function deleteRow(index, id) {
  try {
    loading.value = true;
    disciplinas.value.splice(index, 1);

    const response = await CourseAndSubjectModule.actions.deleteSubject(id);
    if (response.data.status === true) {
      toast.success(response.data.message, {
        autoClose: 1000,
      });
    }
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

const getDisciplinas = async (page = 1) => {
  loading.value = true;

  await CourseAndSubjectModule.actions
    .listSubejects({
      search: searchQuery.value,
      page: page,
    })
    .then((response) => {
      console.log(response.data.data);

      disciplinas.value = response.data.data;
      total.value = response.data.total;
      perPage.value = response.data.per_page;
      current_page.value = response.data.current_page;
    })
    .catch((error) => {
      console.log(error);
      toastr.error(
        "Erro Na busca de dados do departamento ou contacte o administrador"
      );
    })
    .finally(() => {
      loading.value = false;
    });
};
async function getCourses() {
  try {
    loading.value = true;
    const response = await CourseAndSubjectModule.actions.getCourses();
    courses.value = response.data;
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

async function getAcademicYear() {
  try {
    loading.value = true;
    const resp = await SubjectStoreModule.actions.getAcademicYear();

    academicYear.value = resp.data.data;
  } catch (error) {
    console.log();
  } finally {
    loading.value = false;
  }
}

async function getSemester() {
  try {
    loading.value = true;
    const resp = await SubjectStoreModule.actions.getSemester();

    semesters.value = resp.data;
  } catch (error) {
    console.log();
  } finally {
    loading.value = false;
  }
}

async function getSubject() {
  try {
    loading.value = true;

    const resp = await CourseAndSubjectModule.actions.getSubjects();
    Subject.value = resp.data;
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

async function sendData() {
  loading.value = true;

  try {
    if (formData.value.id_course == "") {
      return toast.info("Informe o curso", {
        autoClose: 1000,
      });
    }
    if (formData.value.id_subject.length == "") {
      return toast.info("Informe o ano", {
        autoClose: 1000,
      });
    }
    if (formData.value.semester_id == "") {
      return toast.info("Informe o semestre", {
        autoClose: 1000,
      });
    }

    if (formData.value.academic_year_id == "") {
      return toast.info("Informe o ano", {
        autoClose: 1000,
      });
    }

    const resp = await CourseAndSubjectModule.actions.createCourseDisciplina(
      formData.value
    );
    if (resp.data.status === true) {
      toast.success(resp.data.message, {
        autoClose: 1000,
      });
      clearFields();
    } else {
      toast.info(resp.data.message, {
        autoClose: 1000,
      });
    }
    console.log(resp.data);
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
}

function clearFields() {
  formData.value.id_course = "";
  formData.value.id_subject = [];
  formData.value.semester_id = "";
  formData.value.academic_year_id = "";
}

onMounted(() => {
  getCourses();
  getSubject();
  getAcademicYear();
  getSemester();
  getDisciplinas();
});
</script>
  